var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$props.itemDetail.componentSubcode === "ba_b"
      ? _c(
          "div",
          [
            _c(
              "el-carousel",
              {
                staticStyle: { "border-radius": "0px" },
                attrs: {
                  arrow: "never",
                  height: "85px",
                  "indicator-position": "none",
                },
              },
              _vm._l(_vm.dataList, function (item, index) {
                return _c(
                  "el-carousel-item",
                  { key: index },
                  [
                    _c("el-image", {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: {
                        src: item.bannerPic
                          ? item.bannerPic
                          : require("@/assets/customPage/" +
                              _vm.$props.itemDetail.componentSubcode +
                              "_" +
                              (index + 1) +
                              ".png"),
                        fit: "cover",
                      },
                    }),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        )
      : _vm.$props.itemDetail.componentSubcode === "ba_s"
      ? _c(
          "div",
          [
            _c(
              "el-carousel",
              {
                staticStyle: { "border-radius": "0px" },
                attrs: {
                  arrow: "never",
                  height: "70px",
                  "indicator-position": "none",
                },
              },
              _vm._l(_vm.dataList, function (item, index) {
                return _c(
                  "el-carousel-item",
                  { key: index },
                  [
                    _c("el-image", {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: {
                        src: item.bannerPic
                          ? item.bannerPic
                          : require("@/assets/customPage/" +
                              _vm.$props.itemDetail.componentSubcode +
                              "_" +
                              (index + 1) +
                              ".png"),
                        fit: "cover",
                      },
                    }),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }